import { useParams } from "react-router-dom";
import Layout from "../../shared/Layout";
import { useSnippet } from "../../snippets/hooks/useSnippet";
import BlueskyPost from "./components/BlueskyPost";
import { useEffect, useState } from "react";
import ViewOnlySnippet from "../../snippets/components/ViewOnlySnippet";
import ThreadsPost from "./components/ThreadsPost";

export default function CodePost() {
  const { id } = useParams();
  const { loadedSnippet, taskLoading, isError } = useSnippet({ id });
  const [post, setPost] = useState("");

  return (
    <Layout center={false}>
      <div className="prose ">
        <div></div>
        {loadedSnippet &&
          ViewOnlySnippet({
            snippet: loadedSnippet,
          })}
        <div className="mx-0 md:mx-4">
          <div className="flex flex-col">
            <h2>Create your post here</h2>
            <label className="mb-4">
              Use this tool to create posts for Bluesky, Threads, Twitter,
              Mastodon, and more.
            </label>
            <textarea
              className="border rounded-md p-4"
              placeholder="Write your post here"
              value={post}
              onChange={(e) => setPost(e.target.value)}
            ></textarea>
          </div>
        </div>
        <div className="divider"></div>
        <div className="grid grid-cols-2 mx-0 md:mx-4 mb-8 gap-4">
          <BlueskyPost masterPost={post} />
          <ThreadsPost masterPost={post} />
          <BlueskyPost masterPost={post} />
          <ThreadsPost masterPost={post} />
        </div>
      </div>
    </Layout>
  );
}
